import RequestCodeSnippet_vue_vue_type_script_setup_true_lang_default from "./RequestCodeSnippet.vue_vue_type_script_setup_true_lang.js";
//#region src/v2/blocks/request-block/components/RequestCodeSnippet.vue
var RequestCodeSnippet_default = RequestCodeSnippet_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { RequestCodeSnippet_default as default };

//# sourceMappingURL=RequestCodeSnippet.vue.js.map